<template>
  <ul class="fish timeline">
    <slot></slot>
  </ul>
</template>
<script>
  export default {
    name: 'fish-timeline'
  }
</script>


// WEBPACK FOOTER //
// src/components/Timeline.vue